<template>
	<div class="header header-storekeeper">
		<div class="section-action">
			<UiButtonMenu
				class="btn__menu"
				@click="openSideBar"
			/>
		</div>
		<!-- <HeaderConnectionStatus /> -->
		<div class="header__wrapper">
			<div class="section-info">
				<div class="card__info-driver">
					<UiIcon
						name="profile-circle"
						folder="profile"
						width="24px"
						color="var(--white)"
					/>
					<div class="content">
						<TypographyKTypographyBody6
							class="title"
							color="#D4D4DD"
							>{{ 'Кладовщик' }}</TypographyKTypographyBody6
						>
						<TypographyKTypographyBody5
							class="subtitle"
							color="var(--white)"
							>{{ headerInfo?.name }}</TypographyKTypographyBody5
						>
					</div>
				</div>
				<div class="block-actions">
					<UiButtonIcon
						padding="10px"
						class="btn btn-search"
						:class="{ '--active': storekeeperStore.isSearchMode }"
						@click="setSearchMode"
					>
						<UiIcon
							:name="'search'"
							:height="22"
							:width="22"
							color="#ffffff"
						/>
					</UiButtonIcon>
					<UiButtonIcon
						padding="9px"
						class="btn btn__add-cargo"
						:disabled="storekeeperStore.isSearchMode"
						@click="addedNewCargo"
					>
						<Icon
							:name="'proicons:box-add'"
							size="24"
							class="icon"
						/>
					</UiButtonIcon>
				</div>
			</div>
			<div v-if="storekeeperStore.isSearchMode">
				<div class="section-find-cargo">
					<UiInput
						v-model="payloadSearch"
						placeholder="Поиск по названию и номеру"
					>
						<template #left-icon>
							<UiIcon
								name="search"
								width="19"
							/>
						</template>
						<template #right-icon>
							<UiButtonIcon
								background="transparent"
								padding="0px"
								@click="openBarCodeScanner"
							>
								<Icon
									name="fluent:barcode-scanner-24-filled"
									class="bar-code"
								/>
							</UiButtonIcon>
						</template>
					</UiInput>
					<UiButton
						label="Найти"
						:color="ButtonType.primary"
						:size="ButtonSizeType.big"
						:is-spinner-loading="loading.searchByNumber"
						@click="searchByNumber"
						:style="{ minWidth: '90px' }"
					></UiButton>
				</div>
			</div>
			<div
				class="section-statuses"
				v-else
			>
				<div
					class="statuses"
					:class="{ '--two': storekeeperStatuses?.length === 2 }"
				>
					<div
						v-for="status in storekeeperStatuses"
						:key="status.id"
						class="cargo"
						:class="{ cargo__active: status.storekeeperFilter === currentFilterType }"
						:style="{
							color: status.storekeeperFilter === currentFilterType ? status.backgroundColor : 'var(--black)'
						}"
						@click="setFilterTypeCargo(status.storekeeperFilter)"
					>
						<div class="cargo__icon-wrapper">
							<UiIcon
								:name="status.variableName"
								folder="cargos"
								:color="status.storekeeperFilter === currentFilterType ? status?.backgroundColor : 'var(--black)'"
								v-if="status.variableName"
							/>
							<TypographyKTypographyBody5
								:color="status?.backgroundColor"
								font-type="semi-bold"
							>
								({{ headerInfo?.[status.variableName] || 0 }})
							</TypographyKTypographyBody5>
						</div>

						<TypographyKTypographyBody4 class="cargo__title">
							{{ status?.name }}
						</TypographyKTypographyBody4>
					</div>
				</div>
				<div class="block-date">
					<UiDatePicker
						v-model="chooseDate"
						:date-picker-unique-id="'date-picker-wrapper-week-start'"
						#default="{ isOpen }"
						@chooseDate="chooseDateForGetCargo"
					>
						<UiIcon
							name="calendar"
							color="#fff"
							additional-color="#fff"
						/>
					</UiDatePicker>
					<TypographyKTypographyBody4
						color="var(--white)"
						font-type="semi-bold"
					>
						{{ getCurrentDate }}
					</TypographyKTypographyBody4>
				</div>
			</div>
		</div>
	</div>
	<SideBar
		v-if="isSideBarOpen"
		@closeSideBar="closeSideBar"
		@openSupportChat="openSupportChat"
	/>
</template>

<script setup lang="ts">
	import { AlertsTypes } from '~/const/notification';
	import { getDateInLocaleString } from '~/helpers/date';
	import { useDictionariesStore } from '~/store/dictionaries.store';
	import { useNotificationStore } from '~/store/notification.store';
	import { useStorekeeperStore } from '~/store/storekeeper.store';
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';
	const { startScan, isScanning, scanResult, error } = useBarcodeScanner();

	const emits = defineEmits(['openSupportChat']);
	const isSideBarOpen = ref(false);
	const storekeeperStore = useStorekeeperStore();
	const { getStorekeeperStatuses } = useDictionariesStore();
	const notificationStore = useNotificationStore();
	const pageReqInterval = ref<NodeJS.Timeout | null>(null);
	const headerInfo = storeToRefs(storekeeperStore).headerInfo;
	const payloadSearch = ref('');
	const isToday = computed(() => {
		const selectedDate = new Date(chooseDate.value);
		const today = new Date();

		const isToday =
			selectedDate.getDate() === today.getDate() &&
			selectedDate.getMonth() === today.getMonth() &&
			selectedDate.getFullYear() === today.getFullYear();

		return isToday;
	});
	const getCurrentDate = computed(() => {
		if (isToday.value) {
			return 'Сегодня';
		}
		return getDateInLocaleString(chooseDate.value, { showTime: false, year: 'numeric' });
	});
	const currentFilterType = storeToRefs(storekeeperStore).filterRequestsType;
	const storekeeperStatuses = computed(() => {
		return Array.from(useDictionariesStore().storekeeperStatuses?.values() || []).filter((s) => s?.visible);
	});

	const chooseDate = storeToRefs(storekeeperStore).chooseDate;
	const isInfoModalOpen = storeToRefs(storekeeperStore).isInfoModalOpen;
	const currentCargo = storeToRefs(storekeeperStore).currentCargo;
	const loading = reactive({
		searchByNumber: false
	});

	const addedNewCargo = () => {
		currentCargo.value = null;
		isInfoModalOpen.value = true;
	};

	const searchByNumber = async () => {
		if (!payloadSearch.value) {
			notificationStore.addNewAlert('Введите номер груза', 3000, AlertsTypes.WARNING);
			return;
		}
		loading.searchByNumber = true;
		await storekeeperStore.storekeeperCargoSearchByNumber({ number: payloadSearch.value });
		loading.searchByNumber = false;
	};

	const chooseDateForGetCargo = () => {
		storekeeperStore.virtualCargoGetAll(true);
		storekeeperStore.getHeaderInfo();
	};

	const openBarCodeScanner = async () => {
		if (isScanning.value) return;
		const response = await startScan();

		if (response) {
			payloadSearch.value = response;
			searchByNumber();
		}
	};

	const setSearchMode = () => {
		storekeeperStore.isSearchMode = !storekeeperStore.isSearchMode;

		if (!storekeeperStore.isSearchMode) {
			getHeaderInfo();
			storekeeperStore.virtualCargoGetAll();
		}
	};

	const setFilterTypeCargo = (type: number) => {
		if (currentFilterType.value === type) {
			storekeeperStore.setFilterRequestsType(null);
		} else {
			storekeeperStore.setFilterRequestsType(type);
		}

		storekeeperStore.virtualCargoGetAll(true);
	};

	const getHeaderInfo = async () => {
		await storekeeperStore.getHeaderInfo();
	};

	const openSideBar = () => {
		isSideBarOpen.value = true;
	};

	const closeSideBar = () => {
		isSideBarOpen.value = false;
	};

	const openSupportChat = () => {
		emits('openSupportChat', '');
	};

	getHeaderInfo();
	getStorekeeperStatuses();

	onMounted(() => {
		const startInterval = async () => {
			pageReqInterval.value = setTimeout(async () => {
				await getHeaderInfo();
				if (pageReqInterval.value) startInterval();
			}, 20000);
		};
		startInterval();
	});

	onUnmounted(() => {
		if (pageReqInterval.value) {
			clearTimeout(pageReqInterval.value);
			pageReqInterval.value = null;
		}
	});
</script>

<style scoped lang="scss">
	.section-find-cargo {
		display: flex;
		gap: 14px;
		margin-top: 20px;

		.bar-code {
			font-size: 31px !important;
			color: #888888;
			cursor: pointer;
		}
	}
	.btn__add-cargo {
		.icon {
			color: #ffffff;
		}
	}
	.statuses {
		display: grid;
		grid-template-columns: 1fr 1fr 1fr;
		gap: 8px;

		.cargo {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 4px;
			background-color: var(--white);
			border-radius: 16px;
			padding: 2px 4px;
			height: 64px;
			cursor: pointer;

			&__icon-wrapper {
				display: flex;
				align-items: center;
				gap: 5px;
			}

			&__title {
				display: flex;
				white-space: nowrap;
				gap: 5px;
			}

			.count {
			}

			&__active {
				border: 1.8px solid; /* резервируем место, если нужно */
				box-shadow: inset 0 0 0 2.5px #264688; /* внутренняя обводка */
			}
		}

		&.--two {
			grid-template-columns: 1fr 1fr;
		}
	}
	.header {
		display: flex;
		flex-direction: column;
		gap: 20px;
		justify-content: center;
		align-items: center;
		background-color: transparent;
		padding: 20px 0px 0px 0px;
		width: 100%;

		&__wrapper {
			display: flex;
			flex-direction: column;
			width: 100%;
			max-width: 800px;
		}

		.section-statuses {
			display: flex;
			flex-direction: column;
			gap: 14px;
			width: 100%;
			margin-top: 16px;

			.block-date {
				display: flex;
				gap: 10px;
				align-items: center;
			}
		}

		.section-info {
			display: flex;
			align-items: center;
			width: 100%;

			.block-actions {
				display: flex;
				gap: 10px;
				width: min-content;

				.btn-search {
					position: relative;
					&.--active {
						&:after {
							position: absolute;
							content: '';

							border: 1px solid #ffffff;
							width: 100%;
							height: 100%;
							border-radius: 11px;
						}
					}
				}

				.btn {
					background: linear-gradient(90deg, rgba(239, 242, 246, 0.28) 40%, rgba(185, 177, 228, 0.28) 100%);
					width: 41px;
					height: 41px;
				}
			}

			.card__info-driver {
				display: flex;
				align-items: center;
				gap: 10px;
				width: 100%;
				background: linear-gradient(90deg, rgba(239, 242, 246, 0.28) 40%, rgba(185, 177, 228, 0.28) 100%);
				min-height: 40px;
				max-height: 40px;
				border-radius: 12px;
				margin-right: 16px;
				padding: 8px;

				.content {
					display: flex;
					flex-direction: column;
					gap: 3px;
					justify-content: center;
					overflow: hidden;
				}

				&:last-child {
					margin-right: 0px;
				}
			}
		}

		.section-action {
			display: flex;
			align-items: center;
			margin-left: auto;
			margin-bottom: 10px;

			.btn__menu {
				margin-left: 25px;
			}
		}

		@media (max-width: $extra-sm) {
			//padding: 20px 15px;
		}
	}
</style>
